import { asText } from "@prismicio/helpers";
import { useEffect, useRef } from "react";
import type { NotFound404PageDocument } from "prismicio-types";
import { usePrismicLabels } from "~/hooks/usePrismicLabel";
import { useWv404Page } from "~/hooks/useDataLayer";

const FALLBACK_BANNER =
  "https://images.prismic.io/wovar-rb2-dev/cede95e0-a4b8-4305-b3e2-452a13b17944_wovar-404.jpg?auto=compress,format";

export default function Wv404Page({
  page,
}: {
  page: NotFound404PageDocument | null;
}) {
  const { $pt } = usePrismicLabels();
  const gtm404Page = useWv404Page();
  const isEventFiredRef = useRef(false);
  useEffect(() => {
    if (!isEventFiredRef.current) {
      gtm404Page();
      isEventFiredRef.current = true;
    }
  }, []);

  const banner = page?.data.page_banner;
  const title = asText(page?.data.page_title);
  // The description field holds raw HTML authored in Prismic. asText returns it
  // verbatim (the literal markup string), and we inject it with
  // dangerouslySetInnerHTML so it renders as HTML instead of escaped text.
  // (asHTML is wrong here — it would escape the markup as text content.)
  const descriptionHtml = asText(page?.data.page_description);

  const heading =
    title || $pt("not_found_error_heading") || "Helaas, pagina niet gevonden!";

  return (
    <div className="container mt-3 mt-lg-5 mb-5 pb-lg-5 text-center">
      <div className="content">
        <img
          src={banner?.url || FALLBACK_BANNER}
          alt={banner?.alt || "Not Found 404 Banner"}
          loading="lazy"
          width="351"
          height="159"
          className="mb-3 px-5 mx-auto h-auto"
          style={{ maxWidth: "361px" }}
        />
      </div>
      <h1 className="heading xxl">
        <span className="text--strong text--primary">(404)</span> {heading}
      </h1>
      <div className="content">
        {descriptionHtml ? (
          <div dangerouslySetInnerHTML={{ __html: descriptionHtml }} />
        ) : (
          <p>
            {$pt("not_found_error_desc") ||
              "Sorry, we konden de pagina niet voor je vinden!"}
          </p>
        )}
      </div>
    </div>
  );
}
